/**
 * 平台來源
 */
export enum PlatformSource {
  /** FunNow */
  FunNow = 'FunNow',
  /** FunBook */
  FunBook = 'FunBook',
  /** 米其林, by michelin domain */
  Michelin = 'michelin',
  /** booking engine, by custom subdomain & query string `subdomain` */
  BookingEngine = 'booking_engine',
  /** current for attendee form page */
  Niceday = 'Niceday',
}
